import React from 'react';
import ShayariDisplay from './components/ShayariDisplay';

function App() {
  return (
    <div className="min-h-screen bg-white">
      <ShayariDisplay />
    </div>
  );
}

export default App;